export default "__VITE_PUBLIC_ASSET__9c8928ec__"